import * as React from "react";

class DialogJText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogJ-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 287.538 218.229"
      >
        <g>
          <path
            fill="#F17752"
            d="M59.4,86.4c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3h-3.1c-2,0-2.5-0.5-2.5-2.1V82
		h-0.2c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6h-4.7v-4.3c-0.3,0.2-0.6,0.4-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.2-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1h4.1l0.3-0.1l1.2,0.8c-0.5,0.8-1.1,1.8-1.8,2.6
		h5.2v6h-4.8v3.7c0,0.6,0.2,0.7,1,0.7H59.4z M52.4,80.5c0.2-1,0.3-2,0.4-3h-4v3H52.4z M50.5,74.1c-0.5,0.6-1,1.3-1.6,1.9h4.2
		c0.5-0.6,1-1.3,1.4-1.9H50.5z M58.7,77.5h-4.1c-0.1,1.1-0.2,2.1-0.4,3h4.5V77.5z M57.5,82.1c0.9,0.7,2,1.7,2.5,2.4l-1.2,1
		c-0.5-0.7-1.6-1.8-2.5-2.5L57.5,82.1z"
          />
          <path
            fill="#F17752"
            d="M77.6,86.4c0.8,0,0.9-0.3,1-2.1c0.4,0.3,1.1,0.5,1.5,0.6c-0.2,2.4-0.7,3-2.3,3h-3.1c-2,0-2.5-0.5-2.5-2.1V82
		h-0.2c-1,2.7-3,4.8-7.4,6c-0.2-0.4-0.6-1.1-0.9-1.4c3.8-0.9,5.6-2.6,6.5-4.6h-4.7v-4.3c-0.3,0.2-0.6,0.4-0.9,0.7
		c-0.3-0.4-0.8-1-1.2-1.2c2.5-1.6,4.2-3.9,5.2-5.7l1.8,0.3c-0.2,0.3-0.4,0.7-0.6,1h4.1l0.3-0.1l1.2,0.8c-0.4,0.8-1.1,1.8-1.8,2.6
		h5.2v6h-4.8v3.7c0,0.6,0.2,0.7,1,0.7H77.6z M70.6,80.5c0.2-1,0.3-2,0.4-3h-4v3H70.6z M68.8,74.1c-0.5,0.6-1,1.3-1.6,1.9h4.2
		c0.5-0.6,1-1.3,1.4-1.9H68.8z M76.9,77.5h-4.1c-0.1,1.1-0.2,2.1-0.4,3h4.5V77.5z M75.7,82.1c0.9,0.7,2,1.7,2.5,2.4l-1.2,1
		c-0.5-0.7-1.6-1.8-2.5-2.5L75.7,82.1z"
          />
          <path
            fill="#F17752"
            d="M94.4,83c-0.5,0.9-1.2,1.6-2,2.3c2.1,0.5,3.9,1,5.3,1.5l-1.5,1.2c-1.4-0.5-3.3-1.1-5.5-1.6
		c-2,1-4.7,1.4-8.1,1.7c-0.1-0.5-0.4-1.1-0.7-1.5c2.4-0.1,4.5-0.4,6.1-0.8c-1.3-0.3-2.6-0.5-3.9-0.7c0.5-0.6,1-1.2,1.5-1.9H82v-1.4
		h4.6c0.4-0.6,0.7-1.2,1-1.8l1.7,0.4c-0.2,0.5-0.5,1-0.8,1.4h4.8c0.1-0.3,0.3-0.7,0.4-1l1.6,0.4c-0.1,0.2-0.1,0.4-0.2,0.6H98V83
		H94.4z M87,73.6h-4.8v-1.5h15.4v1.5h-5v1.3H97v4.8H83.1v-4.8H87V73.6z M84.7,78.4H87v-2.1h-2.4V78.4z M87.5,83
		c-0.3,0.4-0.5,0.8-0.8,1.1c1.2,0.2,2.4,0.4,3.6,0.7c0.8-0.5,1.5-1.1,2.1-1.8H87.5z M91.1,73.6h-2.5v1.3h2.5V73.6z M88.6,78.4h2.5
		v-2.1h-2.5V78.4z M92.7,76.3v2.1h2.6v-2.1H92.7z"
          />
          <path
            fill="#F17752"
            d="M100.9,73.3h7.8V75H103v3.7h4.9v1.8H103v4.3h5.9v1.8h-8V73.3z"
          />
          <path
            fill="#F17752"
            d="M111.2,83.9c0-2.1,1.8-3.2,5.9-3.7c0-1.2-0.4-2.2-1.9-2.2c-1,0-2,0.5-2.9,1l-0.8-1.4c1-0.6,2.4-1.3,4-1.3
		c2.5,0,3.6,1.6,3.6,4.2v6h-1.7l-0.2-1.1h-0.1c-0.9,0.8-2,1.4-3.2,1.4C112.4,86.8,111.2,85.7,111.2,83.9z M117.1,84v-2.4
		c-2.9,0.4-3.9,1.1-3.9,2.2c0,1,0.7,1.4,1.5,1.4C115.6,85.1,116.3,84.7,117.1,84z"
          />
          <path
            fill="#F17752"
            d="M121.3,85.4l1-1.3c0.9,0.7,1.7,1.1,2.8,1.1c1.2,0,1.7-0.6,1.7-1.3c0-0.9-1.1-1.3-2.2-1.7
		c-1.3-0.5-2.8-1.2-2.8-2.9c0-1.7,1.3-2.9,3.5-2.9c1.3,0,2.4,0.5,3.2,1.2l-1,1.3c-0.7-0.5-1.4-0.9-2.2-0.9c-1.1,0-1.6,0.5-1.6,1.2
		c0,0.8,1,1.2,2.1,1.6c1.4,0.5,2.9,1.1,2.9,3c0,1.7-1.3,3-3.8,3C123.6,86.8,122.2,86.2,121.3,85.4z"
          />
          <path
            fill="#F17752"
            d="M130.5,81.6c0-3.3,2.2-5.2,4.7-5.2s4.7,1.9,4.7,5.2c0,3.3-2.2,5.2-4.7,5.2S130.5,84.9,130.5,81.6z M137.7,81.6
		c0-2.1-1-3.5-2.5-3.5c-1.5,0-2.5,1.4-2.5,3.5c0,2.1,1,3.5,2.5,3.5C136.7,85.1,137.7,83.7,137.7,81.6z"
          />
          <path
            fill="#F17752"
            d="M142.4,76.6h1.7l0.2,1.4h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.1,0,3,1.4,3,3.9v6.2h-2.1v-6c0-1.7-0.5-2.4-1.7-2.4
		c-0.9,0-1.5,0.5-2.4,1.4v7h-2.1V76.6z"
          />
          <path
            fill="#F17752"
            d="M156.4,82v-4.2c-0.7,1.3-1.6,2.5-2.4,3.2c-0.3-0.4-0.8-0.9-1.1-1.2c1.3-0.9,2.5-2.6,3.3-4.3h-2.8v-1.4h3.1
		v-2.6h1.6v2.6h2.7v1.4H158v0.9c0.7,0.4,2.5,1.7,2.9,2.1l-0.9,1.4c-0.4-0.5-1.3-1.2-2-1.9V82L156.4,82z M153.1,86.3
		c0.7-1,1.3-2.4,1.6-3.7l1.5,0.6c-0.4,1.2-0.9,2.8-1.6,3.9L153.1,86.3z M163.4,86.1c0.8,0,1-0.3,1.1-2.1c0.4,0.3,1,0.5,1.5,0.6
		c-0.2,2.4-0.7,2.9-2.5,2.9H160c-2.2,0-2.7-0.5-2.7-2v-2.7h1.7v2.7c0,0.5,0.2,0.6,1.2,0.6H163.4z M160.9,81.5
		c0.8,0.8,1.9,1.8,2.5,2.5l-1.2,1c-0.5-0.7-1.6-1.8-2.4-2.6L160.9,81.5z M168.6,81.8h-7.1v-9.4h7.1V81.8z M167,73.7h-4v1.4h4V73.7z
		 M167,76.4h-4v1.4h4V76.4z M167,79h-4v1.4h4V79z M167.3,82.3c0.7,1.1,1.7,2.6,2.2,3.6l-1.5,0.8c-0.4-0.9-1.4-2.5-2.1-3.7
		L167.3,82.3z"
          />
          <path
            fill="#F17752"
            d="M176.6,72c-0.5,1.3-1.1,2.7-1.8,3.9v12h-1.6v-9.4c-0.4,0.6-0.9,1.2-1.3,1.7c-0.1-0.4-0.6-1.3-0.9-1.7
		c1.6-1.7,3.1-4.3,4-7L176.6,72z M186.9,80.5c-0.6,0.3-1.2,0.7-1.9,1c0.6,1.7,1.6,3.3,2.8,4.1c-0.3,0.3-0.8,0.9-1,1.2
		c-1.4-1-2.4-2.8-3-4.8c-0.2,0.1-0.5,0.2-0.6,0.3c0.7,2,0.4,4-0.4,4.8c-0.5,0.5-1,0.7-1.7,0.7c-0.3,0-0.7,0-1.2,0
		c0-0.4-0.1-1-0.4-1.4c0.5,0.1,0.9,0.1,1.2,0.1c0.4,0,0.6-0.1,0.9-0.4c0.3-0.3,0.5-1.2,0.4-2.2c-1.5,1.4-3.7,2.6-5.6,3.2
		c-0.2-0.3-0.6-0.9-1-1.2c2.2-0.7,4.8-2,6.2-3.4c-0.1-0.3-0.2-0.5-0.3-0.8c-1.3,1.1-3.3,2.2-4.8,2.7c-0.2-0.3-0.6-0.8-0.9-1.1
		c1.7-0.5,4-1.6,5.1-2.6c-0.2-0.3-0.4-0.5-0.6-0.7c-1.2,0.8-2.6,1.5-3.7,2c-0.2-0.3-0.6-0.8-0.9-1.1c1.3-0.4,2.8-1.1,4-1.8h-2.6
		v-2.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2-0.3-0.7-0.9-1-1.1c1.9-1.3,3.3-3.2,4-4.6l1.5,0.3c-0.2,0.3-0.3,0.6-0.5,1h3l0.3-0.1l1,0.7
		c-0.4,0.6-0.9,1.3-1.4,1.9h3.6v4h-5.3l-0.2,0.2c0.7,0.5,1.2,1.2,1.6,1.9c1.1-0.5,2.3-1.3,3-1.8L186.9,80.5z M179.3,74
		c-0.3,0.4-0.6,0.8-1,1.2h3.1c0.3-0.3,0.6-0.8,0.9-1.2H179.3z M178.4,78h2.5v-1.5h-2.5V78z M185.1,76.5h-2.6V78h2.6V76.5z"
          />
          <path
            fill="#F17752"
            d="M195.3,72c-0.4,1.2-1,2.4-1.7,3.6v12.4H192v-9.8c-0.5,0.8-1.1,1.5-1.7,2.1c-0.2-0.4-0.6-1.3-0.9-1.7
		c1.7-1.7,3.4-4.3,4.4-7L195.3,72z M205.9,79.1h-4.6V88h-1.7v-8.8h-4.8v-1.6h4.8v-5.8h1.7v5.8h4.6V79.1z"
          />
          <path
            fill="#F17752"
            d="M210.5,74.3v3.5c0,2.9-0.2,7.3-1.6,10.2c-0.3-0.3-1-0.8-1.3-1c1.2-2.7,1.3-6.5,1.3-9.2v-5h6.8
		c-0.1-0.4-0.2-0.8-0.4-1.2l1.7-0.3c0.2,0.4,0.4,1,0.5,1.5h6.2v1.5H210.5z M212.6,78.4c0,1-0.1,2.1-1,2.9c-0.2-0.2-0.6-0.6-0.8-0.7
		c0.8-0.6,0.9-1.5,0.9-2.2v-0.7h1V78.4z M220.8,83.5c0.9,1.1,2.2,2.7,2.9,3.6l-1.3,0.7c-0.2-0.3-0.4-0.7-0.7-1.1
		c-8.7,0.6-9.6,0.7-10.2,0.9c-0.1-0.3-0.3-1-0.4-1.4c0.5-0.1,1.2-0.3,2.1-0.8c0.5-0.2,1.4-0.7,2.4-1.3c-2.6,0.2-3.1,0.2-3.4,0.3
		c0-0.3-0.2-0.9-0.4-1.3c0.3,0,0.7-0.2,1.2-0.5c0.5-0.2,2.1-1.2,3.2-2.3l1.2,0.7c-1,0.8-2.1,1.5-3.1,2.1l3.1-0.1
		c0.8-0.5,1.7-1.1,2.4-1.7l1.3,0.9c-2.1,1.5-4.2,2.7-6.3,3.7l6-0.4c-0.4-0.5-0.8-1-1.2-1.4L220.8,83.5z M213.4,81v-4h-2.1v-1.3h2.1
		v-0.9h1.3v0.9h2.2V77h-2.2v4H213.4z M218.9,78.4c0,0.9-0.1,1.9-1,2.7c-0.2-0.2-0.5-0.5-0.8-0.6v0.1c-0.1,0-0.4,0.1-0.6,0.1h-0.4
		c-0.8,0-0.9-0.3-0.9-1.1v-1.7h1v1.7c0,0.3,0,0.4,0.2,0.4h0h0c0.1,0,0.4,0,0.6-0.1l0.1,0.6c0.7-0.5,0.8-1.4,0.8-2v-0.7h1V78.4z
		 M219.7,80.9V77h-2.2v-1.3h2.2v-0.9h1.3v0.9h2.7V77h-2.7v3.9H219.7z M223.3,80c0.2,0,0.5,0,0.7-0.1l0.1,0.8
		c-0.1,0.1-0.4,0.1-0.7,0.1h-0.7c-0.8,0-1-0.4-1-1.2v-1.9h1v2c0,0.3,0,0.4,0.2,0.4H223.3z"
          />
          <path
            fill="#F17752"
            d="M231.2,82.1c-0.2-0.6-0.8-1.5-1.2-2.4v8.2h-1.5v-7.6c-0.5,1.7-1.2,3.3-1.9,4.3c-0.2-0.5-0.6-1.1-0.8-1.4
		c1.1-1.5,2.1-4.1,2.6-6.4h-2.2v-1.5h2.3v-3.8h1.5v3.8h1.9v1.5H230v1c0.5,0.6,1.8,2.7,2.1,3.1L231.2,82.1z M235.9,83.1
		c-0.6,2.2-2.1,3.7-3.8,4.5c-0.2-0.3-0.6-0.8-0.9-1.1c1.2-0.5,2.2-1.4,2.9-2.6h-2.3v-1.2h2.9l0.3-0.1L235.9,83.1z M236.3,74.7h-4
		v-1.2h2.1c-0.2-0.5-0.6-1.1-0.9-1.5l1.2-0.5c0.5,0.5,0.9,1.3,1.1,1.8l-0.5,0.2h3.1l-0.3-0.1c0.4-0.6,0.8-1.4,1-1.9l1.5,0.5
		c-0.4,0.6-0.8,1.1-1.1,1.6h2.4v1.2h-4.1v0.9h3.6v1.2h-3.6v1h4.4V79H237c1.1,0.4,2.2,0.8,2.9,1.2l-0.9,1.1c-0.9-0.6-2.7-1.3-4.1-1.7
		l0.5-0.6h-3.7v-1.3h4.4v-1H233v-1.2h3.3V74.7z M242.1,82.1c-0.9,0.7-1.9,1.4-2.7,2c0.9,0.9,2,1.7,3.2,2.1c-0.3,0.3-0.8,0.9-1,1.3
		c-1.5-0.7-2.8-1.9-3.7-3.3v2.2c0,0.7-0.1,1.2-0.7,1.4c-0.5,0.2-1.3,0.3-2.4,0.3c-0.1-0.4-0.3-1-0.4-1.4c0.7,0,1.4,0,1.6,0
		c0.2,0,0.3-0.1,0.3-0.3v-4.4h-3.1v-1.2h4.7v1.1c0.2,0.5,0.5,1,0.8,1.4c0.8-0.6,1.7-1.4,2.2-2L242.1,82.1z"
          />
          <path
            fill="#F17752"
            d="M61.3,95.8c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
		c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1h-4.2c-0.5,1.2-1.1,2.2-1.6,3
		c-0.3-0.3-0.9-0.7-1.3-0.9v8.3h-4.9v1.4h-1.5V95.9h2c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6h2.9v3.4
		c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4H61.3z M47.6,97.4v3.4H51v-3.4H47.6z M51,106.2v-4h-3.3v4H51z M57,104.8
		c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L57,104.8z"
          />
          <path
            fill="#F17752"
            d="M75.7,99.9c0.3,2.5,1.1,6.3,4.4,8.2c-0.5,0.3-1,0.9-1.2,1.3c-2.3-1.5-3.5-3.9-4.1-6.2
		c-0.6,2.3-1.9,4.5-4.4,6.3c-0.2-0.4-0.6-0.8-1-1.2v1.1h-1.6v-6.2h-1.6v0.5c0,1.4-0.3,3.8-1.7,5.3c-0.3-0.2-0.9-0.6-1.3-0.8
		c1.2-1.4,1.4-3.4,1.4-4.6v-0.4h-1.3v-1.5h4.4v-2.3h-3v0h-0.7v-5.8h1.5v4.3h2.2v-5h1.6v15.2c3.2-2.4,4.1-5.4,4.2-8.3H70v-1.7h3.7
		v-0.1v-5h1.6v5.1v0.1h4.6v1.7H75.7z M78.1,97.4c-0.4-0.9-1.3-2.3-2.2-3.2l1.3-0.6c0.9,1,1.8,2.3,2.2,3.2L78.1,97.4z"
          />
          <path
            fill="#F17752"
            d="M84.9,101.1c-0.8-0.6-2.3-1.4-3.5-1.8l0.9-1.3c1.2,0.4,2.8,1.1,3.6,1.7L84.9,101.1z M86.9,103.4
		c-1,2-2.3,4.2-3.4,5.9l-1.4-1c1-1.4,2.5-3.8,3.6-5.9L86.9,103.4z M85.8,96.2c-0.7-0.6-2.1-1.4-3.3-1.9l0.9-1.2
		c1.2,0.4,2.6,1.1,3.3,1.7L85.8,96.2z M96,107.9c0.4,0,0.5-0.4,0.5-2.6c0.4,0.3,1,0.5,1.5,0.6c-0.2,2.7-0.6,3.5-1.9,3.5h-1.6
		c-1.5,0-1.8-0.5-1.8-2.1v-6H91c-0.2,4.1-0.8,6.8-4.4,8.3c-0.2-0.4-0.6-1.1-1-1.4c3.2-1.2,3.6-3.4,3.7-7h-1.7v-7.4H97v7.4h-2.5v6
		c0,0.6,0.1,0.7,0.5,0.7H96z M89.2,99.7h6v-4.3h-6V99.7z"
          />
          <path
            fill="#F17752"
            d="M108.3,96v3l0.3-0.4c2.1,1,4.9,2.6,6.3,3.7l-1.2,1.5c-1.2-1-3.4-2.4-5.3-3.5v9.1h-1.8V96h-6.7v-1.7h15.9V96
		H108.3z"
          />
          <path
            fill="#F17752"
            d="M127,93.5c-0.1,0.1-0.2,0.2-0.3,0.3c1.7,1.5,4.7,2.9,7.5,3.5c-0.3,0.3-0.8,0.9-1.1,1.3
		c-0.4-0.1-0.9-0.3-1.4-0.4v4.7h-12.2v-4.5c-0.5,0.2-0.9,0.3-1.3,0.4c-0.1-0.3-0.6-1-0.9-1.3c3.3-0.8,6.4-2.4,8.1-4.5L127,93.5z
		 M131.8,98.1c-1-0.3-2-0.8-2.9-1.3v0.5h-6.2V97c-0.8,0.5-1.7,0.8-2.6,1.2H131.8z M120.7,103.6H131v5.9h-1.7V109h-6.9v0.6h-1.7
		V103.6z M123.2,99.4c0.4,0.6,0.8,1.4,0.9,2l-1.2,0.4h2.1v-2.5h-3.9v2.5h1.7c-0.1-0.6-0.5-1.4-0.8-2L123.2,99.4z M122.4,104.7v1h6.9
		v-1H122.4z M129.3,107.9v-1h-6.9v1H129.3z M127.9,96.2c-0.7-0.5-1.4-1-2-1.5c-0.6,0.5-1.3,1.1-2,1.5H127.9z M130.4,99.2h-4v2.5h2
		l-1.1-0.3c0.3-0.6,0.7-1.5,0.9-2.1l1.4,0.4c-0.4,0.8-0.8,1.5-1.1,2.1h1.9V99.2z"
          />
          <path
            fill="#F17752"
            d="M142,103.4v4.7c0,0.6-0.1,1-0.5,1.2c-0.4,0.2-1,0.2-1.9,0.2c-0.1-0.4-0.3-0.9-0.5-1.3c0.6,0,1.1,0,1.3,0
		c0.2,0,0.2-0.1,0.2-0.2v-4.7h-2v-6.5h1.6c0.1-0.5,0.2-1.1,0.3-1.6h-2.7v5.3c0,2.6-0.2,6.4-1.3,8.8c-0.2-0.3-0.9-0.7-1.2-0.9
		c1-2.2,1.1-5.5,1.1-7.9v-6.7h7.6v1.4h-1.9l-0.5,1.6h2.3v6.5H142z M140.1,104.4c-0.3,1.4-0.7,2.8-1.3,3.7c-0.3-0.2-0.8-0.5-1.2-0.6
		c0.5-0.9,0.9-2.1,1.2-3.3L140.1,104.4z M140,99.5h2.7v-1.5H140V99.5z M140,102.2h2.7v-1.5H140V102.2z M143.4,107.4
		c-0.1-0.8-0.6-2-1-2.9l1.1-0.4c0.5,0.9,0.9,2.1,1.1,2.8L143.4,107.4z M147.7,107.2c-0.8,0.9-2.2,1.9-3.3,2.4c-0.2-0.3-0.7-0.8-1-1
		c1.1-0.5,2.4-1.4,3-2.1L147.7,107.2z M147.1,96.8c0.1-0.5,0.2-1,0.2-1.5h-3v-1.4h7.6v1.4h-3c-0.1,0.5-0.3,1.1-0.4,1.5h3v9.4h-6.6
		v-9.4H147.1z M150.1,98h-3.7v1.5h3.7V98z M150.1,100.7h-3.7v1.5h3.7V100.7z M150.1,103.4h-3.7v1.5h3.7V103.4z M149.9,106.4
		c0.8,0.7,2,1.6,2.5,2.3l-1.3,0.9c-0.5-0.6-1.6-1.7-2.4-2.4L149.9,106.4z"
          />
          <path
            fill="#F17752"
            d="M153.9,108.3c0.9-0.8,1.7-2,2.2-3.1l1.4,0.6c-0.5,1.1-1.3,2.4-2.2,3.3L153.9,108.3z M169.6,98.4h-15.4v-1.3h4
		c-0.1-0.4-0.3-0.9-0.5-1.3l1.2-0.3h-3.8v-1.3h6.1c-0.1-0.4-0.3-0.7-0.5-1l1.6-0.3c0.3,0.4,0.5,0.9,0.7,1.4h5.7v1.3h-3.6l1.2,0.3
		c-0.3,0.5-0.5,0.9-0.7,1.3h4.1V98.4z M167.6,104.5h-5.9c0.9,0.5,1.8,1,2.3,1.5l-1,1c-0.6-0.6-1.8-1.4-2.8-1.9l0.7-0.6h-4.5v-5.3
		h11.3V104.5z M165.9,100.3h-8.1v1h8.1V100.3z M165.9,102.4h-8.1v1h8.1V102.4z M163.7,108c0.7,0,0.8-0.2,0.9-1.7
		c0.4,0.2,1,0.5,1.4,0.5c-0.2,2-0.6,2.5-2.2,2.5h-3.2c-2,0-2.5-0.4-2.5-1.9v-2.1h1.6v2.1c0,0.5,0.2,0.5,1,0.5H163.7z M159.2,95.5
		c0.3,0.5,0.6,1.1,0.7,1.6h3.9c0.3-0.5,0.5-1.1,0.7-1.6H159.2z M167.4,105c0.9,1,1.9,2.3,2.3,3.2l-1.4,0.7c-0.4-0.9-1.3-2.2-2.2-3.2
		L167.4,105z"
          />
          <path
            fill="#F17752"
            d="M176.9,98.3h2.9v1.5h-2.9v0.4c0.7,0.7,2.5,2.8,2.9,3.3l-1,1.4c-0.4-0.6-1.2-1.8-1.9-2.8v7.3h-1.7v-7.2
		c-0.8,1.9-1.8,3.7-2.9,4.9c-0.2-0.5-0.6-1.1-0.9-1.5c1.3-1.3,2.6-3.6,3.4-5.7h-2.9v-1.5h3.3v-2.7c-0.9,0.2-1.9,0.3-2.8,0.4
		c-0.1-0.4-0.3-0.9-0.5-1.3c2.4-0.3,5.1-0.9,6.7-1.5l1.1,1.3c-0.8,0.3-1.8,0.6-2.9,0.8V98.3z M187.2,94.7v13.9h-1.7v-1.3H182v1.5
		h-1.6v-14H187.2z M185.5,105.7v-9.4H182v9.4H185.5z"
          />
          <path
            fill="#F17752"
            d="M195.2,93.6c-0.5,1.3-1.1,2.6-1.8,3.9v12h-1.6v-9.6c-0.5,0.7-1,1.3-1.5,1.8c-0.2-0.4-0.6-1.3-0.9-1.7
		c1.7-1.7,3.3-4.3,4.3-6.9L195.2,93.6z M203.4,107.9c1.1,0,1.2-0.5,1.4-2.5c0.4,0.3,1,0.5,1.5,0.6c-0.3,2.6-0.8,3.4-2.8,3.4h-4.4
		c-2.3,0-3-0.6-3-2.8v-5.5l-1.6,0.6l-0.7-1.5l2.2-0.9v-4.5h1.6v3.9l2.3-0.9v-4.8h1.5v4.2l2.7-1.1l0.2-0.2l1.3,0.4l-0.1,0.3
		c-0.1,2.6-0.3,6-0.6,8.1l-1.4-0.4c0.2-1.6,0.3-4.2,0.4-6.4l-2.5,1v6.5H200v-5.9l-2.3,0.9v6.1c0,1,0.2,1.3,1.5,1.3H203.4z"
          />
          <path
            fill="#F17752"
            d="M224,102.1v1.4h-15.8v-1.4h7.1v-1.1h-5.4v-1.3h5.4v-0.9c-1.8,0.1-3.7,0.1-5.4,0.1c0-0.3-0.1-0.6-0.2-0.9h-1.1
		v-3.4h6.9c-0.2-0.5-0.5-1-0.7-1.4l1.6-0.5c0.3,0.5,0.8,1.3,1,1.8h6.1v3.4h-1.2l0.1,0.1c-1.5,0.3-3.5,0.5-5.6,0.6v1h5.5v1.3h-5.5
		v1.1H224z M210.3,97.9c1.6,0,3.4-0.1,5-0.2v-1.2h1.6v1.1c1.8-0.1,3.4-0.3,4.6-0.5l0.4,0.4v-1.3h-11.6V97.9z M210.7,104.4h11v5.1
		H220V109h-7.7v0.6h-1.6V104.4z M212.3,105.8v1.9h7.7v-1.9H212.3z"
          />
          <path
            fill="#F17752"
            d="M225.8,101.1c0.4-1.2,0.8-3.2,0.9-4.6l1.2,0.2c-0.1,1.5-0.4,3.6-0.8,4.9L225.8,101.1z M231.1,95.9
		c0.5,1.1,1.1,2.5,1.3,3.4l-1.3,0.6c-0.2-0.9-0.7-2.3-1.2-3.4v13.1h-1.6V93.1h1.6v3.4L231.1,95.9z M241.8,96.2v13.2h-1.7v-0.7h-5.7
		v0.9h-1.6V96.2h3c0.3-1,0.5-2.2,0.7-3.1l1.9,0.2c-0.3,1-0.6,2-0.9,2.9H241.8z M234.4,97.8v3.7h5.7v-3.7H234.4z M240.1,107.1v-4
		h-5.7v4H240.1z"
          />
          <path
            fill="#F17752"
            d="M61.3,117.4c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
		c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1h-4.2c-0.5,1.2-1.1,2.2-1.6,3
		c-0.3-0.3-0.9-0.7-1.3-0.9v8.3h-4.9v1.4h-1.5v-13.2h2c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6h2.9v3.4
		c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4H61.3z M47.6,119v3.4H51V119H47.6z M51,127.8v-4h-3.3v4H51z M57,126.4
		c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L57,126.4z"
          />
          <path
            fill="#F17752"
            d="M80.7,126.1h-1.9v3.2h-1.7v-0.8h-3.8v0.9c0,0.9-0.2,1.3-0.8,1.5c-0.6,0.2-1.5,0.2-3.1,0.2
		c-0.1-0.4-0.3-1-0.6-1.4c1,0,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-1H66v-1.3h5.6v-1.1h-7.2v-1.3h7.2v-1h-5.5v-1.2h5.5v-1.1h-5v-3.3
		h5v-0.9h-6.8V116h6.8v-1.3h1.7v1.3h7v1.4h-7v0.9h5.2v3.3h-5.2v1.1h5.5v2.2h1.9V126.1z M71.6,120.4v-1.1h-3.4v1.1H71.6z M73.3,119.3
		v1.1h3.5v-1.1H73.3z M73.3,124.8h3.8v-1h-3.8V124.8z M77.1,126.1h-3.8v1.1h3.8V126.1z"
          />
          <path
            fill="#F17752"
            d="M90.1,124c-0.7,0.2-1.4,0.4-2.1,0.7v6.4h-1.5v-6l-2.8,0.9l-0.4-1.6c0.9-0.2,2-0.5,3.3-0.9v-3.8H85
		c-0.2,1-0.5,1.8-0.7,2.5c-0.3-0.2-0.9-0.6-1.2-0.8c0.6-1.5,1-3.7,1.1-5.9l1.4,0.2c-0.1,0.8-0.2,1.5-0.3,2.3h1.2v-3.6H88v3.6h1.7
		v1.6H88v3.3l1.9-0.5L90.1,124z M99.6,117.5c0,0,0,0.6,0,0.8c-0.4,8.1-0.7,10.9-1.4,11.8c-0.4,0.5-0.7,0.7-1.3,0.8
		c-0.5,0.1-1.2,0.1-2,0c0-0.5-0.2-1.2-0.5-1.6c0.8,0.1,1.4,0.1,1.8,0.1c0.3,0,0.5-0.1,0.6-0.3c0.5-0.6,0.9-3.2,1.2-10h-0.5
		c-0.9,4.6-2.8,9.4-5.8,11.7c-0.3-0.3-0.9-0.7-1.4-1c2.9-2.1,4.8-6.4,5.7-10.7h-1.2c-0.8,3-2.4,6.3-4.3,8c-0.3-0.3-0.8-0.7-1.3-1
		c1.9-1.4,3.3-4.3,4.2-7.1h-1.3c-0.6,1.3-1.2,2.4-1.9,3.3c-0.3-0.2-0.9-0.7-1.3-1c1.5-1.6,2.5-4.1,3.1-6.8l1.5,0.3
		c-0.2,0.9-0.5,1.8-0.7,2.6H99.6z"
          />
          <path
            fill="#F17752"
            d="M107.1,115.2c-0.4,1.2-0.9,2.4-1.5,3.6v12.4h-1.5v-9.6c-0.5,0.7-0.9,1.4-1.4,2c-0.2-0.4-0.6-1.3-0.8-1.8
		c1.5-1.7,2.9-4.4,3.7-7.1L107.1,115.2z M117.9,119.5c-0.3,2.9-0.8,5.3-1.8,7.3c0.7,1.3,1.5,2.3,2.7,3.1c-0.3,0.3-0.8,0.9-1,1.3
		c-1.1-0.8-1.9-1.8-2.6-2.9c-0.8,1.2-1.8,2.1-3,3c-0.2-0.3-0.7-0.9-1-1.2c1.4-0.8,2.5-1.9,3.3-3.3c-0.6-1.4-1-3-1.2-4.4
		c-0.2,0.5-0.5,0.9-0.8,1.3c-0.1-0.1-0.2-0.3-0.3-0.5v6.2h-3.9v1.2h-1.5v-7.7h1.9v-3.2h-2.3V118h2.3v-3.2h1.6v3.2h2.1v1.5h-2.1v3.2
		h1.7c-0.2-0.2-0.3-0.4-0.4-0.6c1.2-1.8,1.9-4.6,2.3-7.5l1.5,0.3c-0.2,1-0.4,2.1-0.6,3.1h3.9v1.4H117.9z M110.7,124.2h-2.4v3.6h2.4
		V124.2z M114.4,119.5c0,0.1-0.1,0.3-0.1,0.4c0.2,1.6,0.5,3.4,1.1,5c0.6-1.5,0.9-3.4,1.1-5.4H114.4z"
          />
          <path
            fill="#F17752"
            d="M128.6,129c0,0.8-0.2,1.3-0.7,1.5c-0.5,0.3-1.3,0.3-2.4,0.3c-0.1-0.4-0.3-1.1-0.5-1.5c0.8,0,1.5,0,1.7,0
		c0.2,0,0.3-0.1,0.3-0.3v-4h-3c-0.2,2.2-0.7,4.5-1.7,6.1c-0.3-0.3-1-0.7-1.3-0.8c1.5-2.4,1.7-5.8,1.7-8.4v-6.4h6V129z M127,123.5
		V121h-2.8v0.9c0,0.5,0,1.1,0,1.6H127z M124.1,117v2.5h2.8V117H124.1z M136.7,129c0,0.9-0.2,1.4-0.7,1.7c-0.6,0.3-1.4,0.3-2.8,0.3
		c-0.1-0.5-0.3-1.2-0.5-1.6c0.9,0,1.8,0,2.1,0c0.3,0,0.4-0.1,0.4-0.4v-4h-3.4c-0.2,2.2-0.8,4.5-2,6.2c-0.3-0.3-1-0.7-1.4-0.9
		c1.8-2.5,2-6,2-8.7v-6.1h6.4V129z M135.1,123.5V121h-3.2v0.6c0,0.6,0,1.3-0.1,1.9H135.1z M131.9,117v2.5h3.2V117H131.9z"
          />
          <path
            fill="#F17752"
            d="M154.3,121.7c-0.7,2.5-1.8,4.4-3.3,5.9c1.5,1,3.4,1.6,5.6,2c-0.4,0.4-0.8,1.1-1.1,1.5
		c-2.3-0.5-4.2-1.3-5.8-2.4c-1.5,1.1-3.2,1.9-5.1,2.5c-0.2-0.4-0.6-1.1-1-1.4c1.7-0.4,3.3-1.1,4.7-2.1c-1.1-1.1-2-2.4-2.8-3.9
		c-0.8,2.5-2.1,5-4.1,6.8c-0.3-0.4-0.9-0.8-1.4-1.2c3.2-2.6,4.4-6.9,4.9-10.3h-4.2v-1.6h4.5c0.1-1.3,0.1-2.3,0.2-2.9h1.7
		c0,0.6-0.1,1.6-0.2,2.9h9.3v1.6h-9.5c-0.1,0.7-0.2,1.4-0.4,2.1h6.7l0.3-0.1L154.3,121.7z M146.8,122.9c0.7,1.4,1.6,2.7,2.8,3.7
		c1.1-1,1.9-2.2,2.5-3.7H146.8z"
          />
          <path
            fill="#F17752"
            d="M160.5,131.1c1.4-0.5,2.2-1.3,2.3-2.4c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.5-1.5-1.4c0-0.9,0.7-1.4,1.5-1.4
		c1.1,0,1.7,0.9,1.7,2.3c0,2-1.3,3.5-3.3,4.2L160.5,131.1z"
          />
          <path
            fill="#F17752"
            d="M185.3,128.7v1.7h-16v-1.7h5.2v-9h-4.8V118h3.9c-0.3-0.8-0.9-2-1.5-2.8l1.5-0.6c0.7,0.9,1.4,2.1,1.7,3
		l-0.9,0.4h5.2l-0.4-0.1c0.6-0.9,1.4-2.3,1.7-3.3l1.9,0.5c-0.6,1-1.2,2.1-1.8,2.9h3.8v1.7H180v9H185.3z M172,121.2
		c0.8,1.8,1.5,4.1,1.7,5.6l-1.6,0.4c-0.1-1.5-0.8-3.8-1.6-5.6L172,121.2z M176.2,128.7h2.1v-9h-2.1V128.7z M180.6,126.8
		c0.7-1.5,1.5-3.9,1.8-5.7l1.8,0.4c-0.6,2-1.4,4.2-2.1,5.7L180.6,126.8z"
          />
          <path
            fill="#F17752"
            d="M204.2,128.8v1.6h-16v-1.6h2.8v-13.1h10.7v13.1H204.2z M192.6,117.2v2.7h7.3v-2.7H192.6z M200,121.5h-7.3v2.8
		h7.3V121.5z M192.6,128.8h7.3V126h-7.3V128.8z"
          />
          <path
            fill="#F17752"
            d="M212.9,123.9c-0.7,0.2-1.4,0.4-2.1,0.6v4.8c0,0.8-0.2,1.3-0.6,1.5c-0.5,0.3-1.2,0.3-2.3,0.3
		c-0.1-0.4-0.3-1.1-0.5-1.5c0.6,0,1.3,0,1.4,0c0.2,0,0.3-0.1,0.3-0.3V125l-1.9,0.5l-0.4-1.6c0.6-0.1,1.5-0.3,2.3-0.6v-3.7h-2.1v-1.5
		h2.1v-3.5h1.6v3.5h1.8v1.5h-1.8v3.2l1.9-0.5L212.9,123.9z M220.6,129.1c1,0,1.2-0.5,1.4-2.6c0.4,0.3,1.1,0.5,1.6,0.6
		c-0.3,2.6-0.8,3.5-2.9,3.5h-4.3c-2.3,0-3-0.6-3-2.9v-12.4h9.2v9.7h-1.8v-1.2h-5.8v3.8c0,1.1,0.2,1.3,1.4,1.3H220.6z M215.1,117.2
		v5.3h2.1v-5.3H215.1z M220.9,117.2h-2.1v5.3h2.1V117.2z"
          />
          <path
            fill="#F17752"
            d="M240.5,117v14.1h-1.8v-0.9h-9.1v1H228V117h4.5c0.3-0.8,0.5-1.7,0.6-2.4l2,0.2c-0.3,0.8-0.6,1.5-0.9,2.2H240.5z
		 M229.6,118.6v2.3h9.1v-2.3H229.6z M229.6,122.5v2.3h9.1v-2.3H229.6z M238.8,128.7v-2.3h-9.1v2.3H238.8z"
          />
          <path
            fill="#F17752"
            d="M57.7,150.7c1.9,0,2.1-0.5,2.3-3.2c0.5,0.3,1.2,0.6,1.7,0.7c-0.3,3.3-1,4.2-4,4.2h-6.3c-3.1,0-4.1-0.5-4.1-2.8
		v-6.6h10.4V139H47.1v-1.7h12.4v8.5h-1.8v-1.1h-8.7v4.9c0,1,0.4,1.1,2.3,1.1H57.7z"
          />
          <path
            fill="#F17752"
            d="M79.3,139c0,0,0,0.6,0,0.8c-0.3,8.1-0.5,10.9-1.2,11.8c-0.5,0.6-0.9,0.8-1.6,0.8c-0.6,0.1-1.7,0.1-2.7,0
		c0-0.5-0.2-1.2-0.5-1.6c1.2,0.1,2.2,0.1,2.6,0.1c0.4,0,0.6-0.1,0.8-0.3c0.6-0.6,0.8-3.3,1-10.1h-4.2c-0.5,1.2-1.1,2.2-1.6,3
		c-0.3-0.3-0.9-0.7-1.3-0.9v8.3h-4.9v1.4h-1.5v-13.2h2c0.3-0.9,0.5-2.1,0.6-2.9l1.8,0.3c-0.3,0.9-0.6,1.9-0.9,2.6h2.9v3.4
		c1.2-1.5,2.1-3.9,2.7-6.3l1.6,0.4c-0.2,0.8-0.5,1.7-0.7,2.4H79.3z M65.6,140.6v3.4H69v-3.4H65.6z M69,149.4v-4h-3.3v4H69z M75,148
		c-0.5-1.1-1.7-2.9-2.6-4.2l1.3-0.7c1,1.2,2.2,3,2.7,4L75,148z"
          />
          <path
            fill="#F17752"
            d="M84.7,146.8v-4.2c-0.7,1.3-1.6,2.5-2.4,3.2c-0.3-0.4-0.8-0.9-1.1-1.2c1.3-0.9,2.5-2.6,3.3-4.3h-2.8v-1.4h3.1
		v-2.6h1.6v2.6H89v1.4h-2.7v0.9c0.7,0.4,2.5,1.7,2.9,2.1l-0.9,1.4c-0.4-0.5-1.3-1.2-2-1.9v4.1L84.7,146.8z M81.4,151.1
		c0.7-1,1.3-2.4,1.6-3.7l1.5,0.6c-0.4,1.2-0.9,2.8-1.6,3.9L81.4,151.1z M91.6,150.9c0.8,0,1-0.3,1.1-2.1c0.4,0.3,1,0.5,1.5,0.6
		c-0.2,2.4-0.7,2.9-2.5,2.9h-3.5c-2.2,0-2.7-0.5-2.7-2v-2.7h1.7v2.7c0,0.5,0.2,0.6,1.2,0.6H91.6z M89.1,146.3
		c0.8,0.8,1.9,1.8,2.5,2.5l-1.2,1c-0.5-0.7-1.6-1.8-2.4-2.6L89.1,146.3z M96.9,146.6h-7.1v-9.4h7.1V146.6z M95.3,138.5h-4v1.4h4
		V138.5z M95.3,141.2h-4v1.4h4V141.2z M95.3,143.8h-4v1.4h4V143.8z M95.6,147.1c0.7,1.1,1.7,2.6,2.2,3.6l-1.5,0.8
		c-0.4-0.9-1.4-2.5-2.1-3.7L95.6,147.1z"
          />
          <path
            fill="#F17752"
            d="M104.7,136.8c-0.5,1.3-1.1,2.7-1.8,3.9v12h-1.6v-9.4c-0.4,0.6-0.9,1.2-1.3,1.7c-0.1-0.4-0.6-1.3-0.9-1.7
		c1.6-1.7,3.1-4.3,4-7L104.7,136.8z M115,145.3c-0.6,0.3-1.2,0.7-1.9,1c0.6,1.7,1.6,3.3,2.8,4.1c-0.3,0.3-0.8,0.9-1,1.2
		c-1.4-1-2.4-2.8-3-4.8c-0.2,0.1-0.5,0.2-0.6,0.3c0.7,2,0.4,4-0.4,4.8c-0.5,0.5-1,0.7-1.7,0.7c-0.3,0-0.7,0-1.2,0
		c0-0.4-0.1-1-0.4-1.4c0.5,0.1,0.9,0.1,1.2,0.1c0.4,0,0.6-0.1,0.9-0.4c0.3-0.3,0.5-1.2,0.4-2.2c-1.5,1.4-3.7,2.6-5.6,3.2
		c-0.2-0.3-0.6-0.9-1-1.2c2.2-0.7,4.8-2,6.2-3.4c-0.1-0.3-0.2-0.5-0.3-0.8c-1.3,1.1-3.3,2.2-4.8,2.7c-0.2-0.3-0.6-0.8-0.9-1.1
		c1.7-0.5,4-1.6,5.1-2.6c-0.2-0.3-0.4-0.5-0.6-0.7c-1.2,0.8-2.6,1.5-3.7,2c-0.2-0.3-0.6-0.8-0.9-1.1c1.3-0.4,2.8-1.1,4-1.8H105v-2.7
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2-0.3-0.7-0.9-1-1.1c1.9-1.3,3.3-3.2,4-4.6l1.5,0.3c-0.2,0.3-0.3,0.6-0.5,1h3l0.3-0.1l1,0.7
		c-0.4,0.6-0.9,1.3-1.4,1.9h3.6v4h-5.3l-0.2,0.2c0.7,0.5,1.2,1.2,1.6,1.9c1.1-0.5,2.3-1.3,3-1.8L115,145.3z M107.3,138.8
		c-0.3,0.4-0.6,0.8-1,1.2h3.1c0.3-0.3,0.6-0.8,0.9-1.2H107.3z M106.5,142.8h2.5v-1.5h-2.5V142.8z M113.2,141.3h-2.6v1.5h2.6V141.3z"
          />
          <path
            fill="#F17752"
            d="M117.5,151.1h16.1v1.2h-16.1V151.1z M133.7,144.4v1.1h-16.1v-1.1h7.1v-0.8h-5.7v-1h5.7v-0.8h-5.3v-1h5.3V140
		h-7.1v-1h7.1v-0.8h-5.2v-1h5.2v-1.1h1.7v1.1h5.4v1.7h1.9v1h-1.9v1.8h-5.4v0.8h6.1v1h-6.1v0.8H133.7z M131.7,146.2v4.2h-12.2v-4.2
		H131.7z M121.2,147.8h3.5V147h-3.5V147.8z M121.2,149.5h3.5v-0.8h-3.5V149.5z M130,147h-3.7v0.8h3.7V147z M130,148.7h-3.7v0.8h3.7
		V148.7z M126.3,139h3.7v-0.8h-3.7V139z M126.3,140.9h3.7V140h-3.7V140.9z"
          />
          <path
            fill="#F17752"
            d="M151.4,138.9v1.6h-9.7c-0.6,1.3-1.3,2.5-2.1,3.6v8.6h-1.7V146c-0.6,0.6-1.2,1.1-1.9,1.6
		c-0.2-0.5-0.6-1.2-0.8-1.6c2-1.4,3.5-3.4,4.6-5.6h-4.1v-1.6h4.9c0.4-0.9,0.6-1.8,0.9-2.6l1.7,0.4c-0.2,0.7-0.5,1.5-0.8,2.2H151.4z
		 M146.9,150.8h4.5v1.6h-10.7v-1.6h4.5v-4.6h-3.9v-1.5h3.9v-3.2h1.7v3.2h3.8v1.5h-3.8V150.8z"
          />
          <path
            fill="#F17752"
            d="M159.1,147.1c-0.1-0.3-0.1-0.6-0.2-0.9c-4,0.6-4.6,0.8-5,1c-0.1-0.3-0.3-1.1-0.5-1.5c0.4-0.1,0.8-0.5,1.4-1.2
		c0.3-0.3,0.8-1,1.5-1.8c-1.8,0.2-2.3,0.3-2.5,0.4c-0.1-0.3-0.3-1.1-0.5-1.5c0.3-0.1,0.7-0.4,1.1-1c0.4-0.5,1.7-2.5,2.5-4.5l1.5,0.6
		c-0.8,1.6-1.8,3.3-2.8,4.6l1.8-0.1c0.5-0.8,1-1.6,1.4-2.4l1.4,0.9c-1.2,2-2.6,3.9-4.1,5.5l2.5-0.3c-0.2-0.5-0.4-1-0.6-1.5l1.2-0.5
		c0.5,1.2,1.1,2.7,1.3,3.6L159.1,147.1z M155.5,148.1c-0.1,1.6-0.5,3.3-0.8,4.4c-0.3-0.2-1-0.4-1.4-0.5c0.4-1.1,0.7-2.7,0.8-4.1
		L155.5,148.1z M157.5,147.7c0.2,1.2,0.4,2.7,0.5,3.8l-1.4,0.3c0-1-0.2-2.6-0.4-3.8L157.5,147.7z M159.4,147.2
		c0.4,1,0.8,2.2,0.9,3.1l-1.3,0.4c-0.1-0.8-0.5-2.2-0.8-3.2L159.4,147.2z M166.7,144.7c0.3,3.8,0.9,6.3,1.6,6.3
		c0.3,0,0.5-0.9,0.5-2.8c0.3,0.3,0.9,0.7,1.3,0.8c-0.2,2.8-0.7,3.5-1.9,3.5c-1.8,0-2.6-3.3-3-7.8h-2.8v5.8l2.7-0.8
		c0,0.4,0.1,1.1,0.2,1.5c-3.5,1.2-4,1.4-4.4,1.7c-0.1-0.4-0.5-1-0.7-1.3c0.3-0.2,0.6-0.6,0.6-1.5V138c2.6-0.4,5.7-1,7.5-1.5l1.2,1.4
		c-0.9,0.3-1.9,0.5-3,0.7c0,1.6,0,3.2,0.1,4.6h3.1v1.6H166.7z M165.1,143.2c-0.1-1.4-0.1-2.8-0.1-4.4c-0.9,0.2-1.7,0.3-2.6,0.4v4
		H165.1z"
          />
          <path
            fill="#F17752"
            d="M187.6,150.2v1.7h-16.1v-1.7h6.6v-13.7h1.8v5.3h6.5v1.7h-6.5v6.7H187.6z"
          />
          <path
            fill="#F17752"
            d="M193.1,146.7c1.6,0,2.8,1.3,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8c-1.5,0-2.8-1.3-2.8-2.8
		C190.3,148,191.6,146.7,193.1,146.7z M193.1,151.2c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7
		C191.4,150.5,192.2,151.2,193.1,151.2z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogJText;



// WEBPACK FOOTER //
// ./src/storyB/components/DialogJText.tsx